import React from 'react'
import {
  Dialog,
  Container,
  IconButton
} from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { ForgotPassword as ForgotPasswordPage } from '../userActions'
import { useStyles } from './style';

const ForgotPassword = ({ open, onClose, component }) => {
  const classes = useStyles();
  return(
    <Dialog
      open={open}
      onClose={onClose}
      classes={{paperScrollPaper: classes.scroller}}>
      <Container maxWidth="xs" className={classes.container}>
        <IconButton
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
          }}
          onClick={onClose}>
          <Close/>
        </IconButton>
        <ForgotPasswordPage onDialog/>
      </Container>
    </Dialog>
  )
}

export default ForgotPassword;
